import { gql } from '@apollo/client';

export default gql`
  mutation updatePreferencesExcludePoa($input: Boolean!) {
    updateBuyerPreferencesExcludePoa(input: $input)
  }
`;
